function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "wgh0mkbnfa",
  d: "M25 37.5l-11.108 5.84c-.977.514-2.187.138-2.7-.84-.205-.39-.276-.835-.202-1.269l2.122-12.368-8.987-8.76c-.79-.77-.807-2.037-.036-2.828.307-.315.71-.52 1.145-.583l12.419-1.805 5.554-11.253c.488-.99 1.688-1.397 2.678-.908.395.194.714.514.908.908l5.554 11.253 12.42 1.805c1.092.159 1.85 1.174 1.69 2.267-.063.435-.268.837-.582 1.144l-8.987 8.76L39.01 41.23c.186 1.089-.545 2.123-1.634 2.31-.433.074-.879.003-1.268-.201L25 37.5z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H100V76H0z",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(25.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "smqx48ltdb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wgh0mkbnfa"
})), /*#__PURE__*/React.createElement("use", {
  stroke: "#00C853",
  strokeLinejoin: "round",
  strokeWidth: 2,
  opacity: 0.689,
  xlinkHref: "#wgh0mkbnfa"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00C853",
  d: "M27 37l-9.344 4.913c-.978.514-2.187.138-2.701-.84-.205-.39-.276-.835-.201-1.269L16.538 29.4l-7.56-7.369c-.79-.77-.806-2.037-.035-2.828.307-.315.709-.52 1.144-.583L20.534 17.1l4.673-9.467c.488-.99 1.688-1.397 2.678-.908.395.194.714.514.908.908l4.673 9.467 10.447 1.518c1.093.159 1.85 1.174 1.692 2.267-.064.435-.269.837-.584 1.144l-7.56 7.37 1.785 10.404c.187 1.089-.544 2.123-1.633 2.31-.433.074-.88.003-1.269-.201L27 37z",
  mask: "url(#smqx48ltdb)",
  opacity: 0.1
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#00C853",
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.574 12L48.574 0",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.821 18.826L71.821 6.826",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000) translate(71.821072, 12.826098) rotate(33.000000) translate(-71.821072, -12.826098)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.688 37.137L87.688 25.137",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000) translate(87.687693, 31.137154) rotate(65.000000) translate(-87.687693, -31.137154)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.136 61.12L91.136 49.12",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000) translate(91.135839, 55.119538) rotate(98.000000) translate(-91.135839, -55.119538)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.011 61.12L6.011 49.12",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000) translate(6.011195, 55.119538) rotate(262.000000) translate(-6.011195, -55.119538)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.459 37.137L9.459 25.137",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000) translate(9.459341, 31.137154) rotate(295.000000) translate(-9.459341, -31.137154)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.326 18.826L25.326 6.826",
  transform: "translate(-162.000000, -386.000000) translate(24.000000, 302.000000) translate(90.000000, 84.000000) translate(48.000000, 0.000000) translate(1.426483, 2.000000) translate(25.325962, 12.826098) rotate(327.000000) translate(-25.325962, -12.826098)"
})))))));
function SvgPlaceholderStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 76,
    viewBox: "0 0 100 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderStar);
export default __webpack_public_path__ + "static/media/placeholder-star.591ca17f006fa3668d4bc37555c665af.svg";
export { ForwardRef as ReactComponent };